import { ExternalLink } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '../../../../lib/utils'
import { type CorgiPolicyLink } from '../../../../models/insurancePolicy'

export function CorgiPolicyLinks({ links, className }: { links: CorgiPolicyLink[]; className?: string }) {
  if (links.length === 0) return null

  return (
    <div className={cn('flex flex-wrap items-center gap-x-4', className)}>
      {links.map((link) => (
        <Button
          key={link.policyNumber}
          size="sm"
          variant="link"
          className="h-auto justify-start px-0 has-[>svg]:px-0"
          href={link.url}
          target="_blank"
        >
          View {link.policyNumber} in Corgi
          <ExternalLink className="size-3" />
        </Button>
      ))}
    </div>
  )
}
